export default __webpack_public_path__ + "static/media/notfound.03752a20.svg";